type NumberFormat = "nepali" | "english";

export function formatWithComma(
  value: number | string = 0,
  decimals = 2,
  format: NumberFormat = "nepali",
): string {
  const numValue = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(numValue)) return "0";

  const formattedValue = numValue.toLocaleString(
    format === "english" ? "en-US" : "en-IN",
    {
      maximumFractionDigits: decimals,
    },
  );

  return formattedValue;
}
